import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import { BlogContext } from '../../context/BlogContext';
import '../../style/Blog.css';
import Typewriter from '../../style/Typewriter';
import PostCard from '../Layout/PostCard';
import TutorialModal from './Tutorial'; // adjust path if needed

const HomePage = () => {
  const { user } = useContext(AuthContext);
  const { blogs, getBlogs } = useContext(BlogContext);
  const [loading, setLoading] = useState(true);
  const [recentPosts, setRecentPosts] = useState([]);
  const [error, setError] = useState(null);
  const [showTutorial, setShowTutorial] = useState(false);


  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        await getBlogs();
      } catch {
        setError('Failed to load blogs. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, [getBlogs]);

  useEffect(() => {
    if (blogs.length > 0) {
      const sorted = [...blogs].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
      setRecentPosts(sorted.slice(0, 2));
    }
  }, [blogs]);

  return (
    <Container className="mt-5 mb-4 text-center">
      {/* Hero / Welcome Section */}
      <div className="retro-window mb-5">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="fw-bold display-5 mb-4">
          <Typewriter text={user ? `Welcome back, ${user.username}!` : "Welcome to Post App!"} />
        </h1>
        <p className="fst-italic fs-5 mb-0">Your go-to place for insightful articles and discussions.</p>
      </div>

   {/* CTA Buttons */}
   <Row className="justify-content-center g-3 mb-5">
        <Col xs={12} md={6} lg={4}>
          <Link to="/posts" className="retro-button w-100">Browse All Posts</Link>
        </Col>
        {user ? (
          <Col xs={12} md={6} lg={4}>
            <Link to="/posts/new" className="retro-button w-100">+ Create New Post</Link>
          </Col>
        ) : (
          <Col xs={12} md={6} lg={4}>
            <Link to="/login" className="retro-button w-100">Not New Here? Login!</Link>
          </Col>
        )}
      </Row>

{/* === Start Here Guide === */}
{!user && (
  <div className="retro-window mb-5">
    <div className="window-dots">
      <span className="dot red" />
      <span className="dot yellow" />
      <span className="dot green" />
    </div>
    <h2 className="text-center mb-4">New Here?</h2>
    <p className="fs-5 text-center">
      Start your journey in just a few steps. Learn how to create your first post and explore community blogs.
    </p>
    <div className="text-center mt-4">
      <button className="retro-button small-btn mb-3" onClick={() => setShowTutorial(true)}>
        Click here to get started!
      </button>
    </div>
  </div>
)}


      {/* <div className="retro-window mb-5">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h2 className="text-center mb-4">Why Choose Post App?</h2>
        <ul className="text-start fs-5" style={{ listStyle: 'square', paddingLeft: '4rem' }}>
          <li>📝 Easy post creation & editing</li>
          <li>👥 Connect with fellow readers and writers</li>
          <li>📚 Read insightful, community-written articles</li>
          <li>💡 Clean retro UI for a fun experience</li>
        </ul>
      </div>

      <div className="retro-window mb-5">
  <div className="window-dots">
    <span className="dot red" />
    <span className="dot yellow" />
    <span className="dot green" />
  </div>
  <h2 className="text-center mb-4">How It Works</h2>
  <ol className="fs-5 text-start" style={{ paddingLeft: '4rem' }}>
    <li>✍️ Sign up or log in</li>
    <li>🧠 Read or write insightful blog posts</li>
    <li>📣 Share, comment, and grow with the community</li>
  </ol>
</div> */}


{/* Recent Blog Posts */}
{loading ? (
  <div className="text-center mt-4">
    <Spinner animation="border" variant="dark" />
  </div>
) : error ? (
  <div className="text-center mt-4">
    <Alert variant="danger">{error}</Alert>
  </div>
) : (
  <div className="retro-window mb-4">
    <div className="window-dots">
      <span className="dot red" />
      <span className="dot yellow" />
      <span className="dot green" />
    </div>
    <h2 className="text-center mb-4">Recent Posts</h2>
    <Row className="g-4 justify-content-center">
      {recentPosts.map((post) => (
        <Col key={post._id} xs={12} md={6} lg={6}>
          <PostCard post={post} />
        </Col>
      ))}
    </Row>
  </div>
)}


      {/* Motivational Quote */}
      <blockquote className="retro-window fst-italic fs-5 text-center mt-5">
        <div className="window-dots mb-2">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        "The desire to write grows with writing." <br />
        — Desiderius Erasmus
      </blockquote>
      <TutorialModal show={showTutorial} onHide={() => setShowTutorial(false)} />

    </Container>

    
  );
};

export default HomePage;
